import { render } from "./FormInputCheckbox.vue?vue&type=template&id=97415156&scoped=true"
import script from "./FormInputCheckbox.vue?vue&type=script&lang=js"
export * from "./FormInputCheckbox.vue?vue&type=script&lang=js"

import "./FormInputCheckbox.vue?vue&type=style&index=0&id=97415156&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97415156"]])

export default __exports__